import { getCloudinaryUrl } from "@swiggy-private/js-utils";

export const TEXTS = {
    HEADING: "Uh-oh, something went wrong",
    DESCRIPTION: "Looks like something is broken, Please refresh or try again later",
    REFRESH: "Refresh",
};

export const SIZE = {
    IMAGE_HEIGHT: "200px",
    IMAGE_WIDTH: "220px",
};

export const DEFAULT_IMAGE_SRC = getCloudinaryUrl(
    "portal/static-assets/images/digital-menu/all-theme-assets/generic_errors.png",
    {
        width: 220 * 2,
        height: 200 * 2,
    }
);

export const DATA_TEST_IDS = {
    REFRESH_CTA: "error-refresh-cta",
    LEFT_ICON: "left-icon",
};
